import { combineReducers } from "redux";

// Front
import Layout from "./layout/reducer";


// Authentication
import forgetPassword from "./auth/forgetpwd/reducer";
import login from "./auth/login/reducer";
import profile from "./auth/profile/reducer";
import account from "./auth/register/reducer";
import providers from "../store/auth/login/providersReducer";
import facilities from "../store/auth/login/facilitiesReducer";
import permissions from "../store/auth/login/permissionsReducer";

const rootReducer = combineReducers({
  // public
  Layout,
  forgetPassword,
  providers,
  facilities,
  permissions,
  login,
  profile,
  account,
});

export default rootReducer;
